import styled from 'styled-components';

export const Container = styled.div`
  padding: 8px 20px;
  border: 1px solid #e2e2ea;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
